<template>
    <div class="d-flex flex-column">
        <div class="d-flex text-nowrap">
            <span><b-icon icon="circle-fill" :variant="variant" class="mr-1"/></span>
            <span>{{ value.status_name }}</span>
        </div>
        <div>
            <small class="text-secondary">{{ extraValue }}</small>
        </div>
    </div>
</template>

<script>
    import {RequestStatus} from "@/pages/AppPages/Requests/request";

    export default {
        name: "RequestStatusCell",
        props: {
            value: { },
            extraValue: {},
        },
        computed: {
            statusName() {
                if (this.request.descriptionObject) {
                    return this.request.statusName
                }
                if (this.request['description_object']) {
                    return this.request['description_object']['status_name']
                }
                return null
            },
            variant() {
                switch (this.value.status) {
                    case RequestStatus.OPEN: return 'warning';
                    case RequestStatus.ASSIGNED: return 'info';
                    case RequestStatus.WIP: return 'primary';
                    case RequestStatus.DONE: return 'success';
                    case RequestStatus.CANCELLED: return 'danger';
                    default: return 'secondary'
                }
            }
        }
    }
</script>

<style scoped>

</style>